module.exports = require('./EntityOfficerNewApplicationView');
